module.exports = require('./EntityOfficerNewApplicationView');
